import { UISubscriptionStatus } from "common/types";

/**
 * Mirrors SubscriptionStatus.non_canceled_and_non_imported_statuses
 */
export const NON_CANCELED_NON_IMPORTED_SUBSCRIPTION_STATUSES: UISubscriptionStatus[] = [
  UISubscriptionStatus.Active,
  UISubscriptionStatus.Paused,
  UISubscriptionStatus.FailedPayment,
];
